module.exports = __webpack_public_path__ + "static/media/logo-buk.15344f24.png";